/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Ana Ekran',
	homePageTabsLabel: 'Ana içerik',
	myContent: 'İçeriğim',
	teamContent: 'Ekip içeriği',
	folder: 'Klasör',
	files: 'Dosyalar',
	actionMenu: 'Eylem menüsü',
	myFolder: 'Klasörlerim',

	emptyFolderNoContent: 'İçerik yok',

	//EmptyStates
	emptyRecentTitle: 'Yakın zamanda bir içerik görüntülemediniz.',
	emptyStateTitle: 'Veri ekleyerek başlayın',
	emptyStateBody: 'Yukarıdaki Verileri karşıya yükle seçeneğini tıklatın veya verileri karşıya yüklemek için sürükleyin ve bırakın.',
	emptySearchResultTitle: 'Aramanız herhangi bir sonuç döndürmedi.',
	emptyPortalTitle: 'Portal yok',
	emptyPortalBody: 'Şu anda herhangi portalınız yok.',
	emptyWsProjectTitle: 'Watson Studio\'da bir not defteri oluşturarak başlayın.',
	emptyWsProjectBody: 'Cognos Analytics\'e geri döndüğünüzde, not defteriniz burada görünecek.',
	emptyFilteredResultTitle: 'Uygulanan süzgeçler herhangi bir sonuç döndürmedi.',
	emptyDialogViewTitle: 'Öğe yok',
	removeFromRecents: 'En son olanlardan kaldır',

	// Welcome Banner
	welcomeBannerGreeting: 'Merhaba. Cognos Analytics with Watson\'a Hoş Geldiniz.',
	welcomeBannerDescription: 'Cognos Analytics with Watson, yapay zeka odaklı self servis analitiğiyle kullanıcıları güçlendirir. Otomatik veri hazırlama, veri keşfi ve görselleştirmelerin nasıl daha güvenli kararlar alınmasını sağlayabileceğini görün.',
	welcomeBannerDescription_trialUser: 'Tanıtım videomuza, ürün turumuza ve Çalışmaya Başlarken sekmesine bakarak hemen başlayabilirsiniz.',
	takeTourButtonLabel: 'Ürün turuna katılın',
	watchVideoButtonLabel: 'Videoyu izleyin',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Ana sayfanızdaki hoş geldiniz başlığını kapatmak istediğinizden emin misiniz? Dilediğiniz zaman Profil ve ayarlar > Ayarlar > Genel sekmesinden bunu yeniden etkinleştirebilirsiniz. ',
	hideWelcomeBannerTitle: 'Hoş geldiniz başlığını kapatın',
	ok: 'Tamam',
	cancel: 'İptal',
	warn: 'Uyarı',
	//howto video dialog
	modal_how_title: 'Cognos Analytics\'e genel bakış videosunu izleyin',
	modal_overview_title: 'Cognos Analytics\'e genel bakış videosunu izleyin',
	modal_how_play: 'Video oynat',
	modal_how_video_title_overview: 'Genel bakış',
	modal_how_video_title_getStarted: '11.2 sürümünü kullanmaya başlama',
	modal_how_video_title_newUI: 'Yeni Cognos deneyimine hoş geldiniz',
	modal_how_video_title_dataModule: 'Veri modüllerine genel bakış',
	modal_how_video_title_explore: 'Veri keşfine genel bakış',
	modal_how_video_title_dashboard: 'Etkileşimli gösterge panolarına genel bakış',
	modal_how_video_title_reporting: 'Raporlamaya genel bakış',
	modal_how_video_title_mobile: 'Cognos\'un gücü avucunuzun içinde',

	// Toolbar
	search: 'Ara',
	addFolder: 'Klasör ekle',
	addLink: 'Bağlantı ekle',
	filter: 'Süzgeç',
	sort: 'Sırala',
	settings: 'Ayarlar',
	tilesView: 'Döşemeler görünümü',
	listView: 'Liste görünümü',
	columnView: 'Sütun görünümü',
	backToSearch: 'Arama sonuçlarına dön',

	// Toolbar Actions
	sortBy: 'Sıralama ölçütü',
	sortOrder: 'Sırala',
	name: 'Ad',
	modifiedTime: 'Değiştirildi',
	type: 'Tip',
	ascending: 'Artan',
	descending: 'Azalan',
	resetSort: 'Sıralamayı sıfırla',

	filterType: 'Tip',
	filterModificationTime: 'Değiştirildi',
	all: 'Tümü',
	today: 'Bugün',
	yesterday: 'Dün',
	pastWeek: 'Geçen hafta',
	pastMonth: 'Geçen ay',
	resetFilters: 'Süzgeçleri sıfırla',
	resultLimit: 'Sonuç sınırı',

	filterSearchPlaceHolder: 'Anahtar sözcüklere göre süz',

	resetFilterTag: 'Süzgeçleri sıfırlamak için X\'i tıklatın.',
	filterTagToolTip: 'Uygulanan süzgeçler: %{appliedFilters}.',

	folderName: 'Klasör adı',
	addAFolder: 'Klasör ekle',
	add: 'Ekle',
	error: 'Hata',
	newFolderDefaultName: 'Yeni Klasör',
	toastCreateNewFolder: '%{nameOfFolder} klasörü %{tabName} içinde oluşturuldu.',
	folderAdded: 'Klasör eklendi',
	refresh: 'Yenile',
	openFolder: 'Klasörü aç',

	addAUrl: 'URL ekle',
	linkName: 'URL adı',
	linkNamePlaceholder: 'URL adı ekle',
	linkDescription: 'Açıklama (isteğe bağlı)',
	linkDescriptionPlaceholder: 'Tanım ekle',
	linkUri: 'URL',
	linkUriPlaceholder: 'Kabul edilebilir etki alanına sahip bir URL ekle',
	acceptableDomains: 'Kabul edilebilir etki alanları',
	viewAcceptableDomains: 'Kabul edilebilir etki alanlarını görüntüle',
	mandatoryField: 'Zorunlu alan',
	linkAdded: 'URL eklendi',
	toastCreateNewLink: '%{nameOfLink}, %{tabName} konumuna eklendi.',
	noEntries: 'Kabul edilebilir etki alanları listesinde bir girdi yok. Yöneticinizle irtibata geçin.',
	unacceptableDomain: 'URL\'niz, geçersiz bir etki alanı kullanıyor. Kullanabileceğiniz etki alanlarının listesini görüntülemek için \'Kabul edilebilir etki alanlarını görüntüle\' seçeneğini tıklatın.',

	compact: 'Küçük',
	short: 'Kısa',
	default: 'Varsayılan',
	rowSize: 'Satır boyutu',

	// GroupyByTypes
	folders: 'Klasörler',
	reports: 'Raporlar',
	dashboards: 'Panolar',
	data: 'Veri',
	packages: 'Paketler',
	explorations: 'Keşifler',
	stories: 'Hikayeler',
	notebooks: 'Not Defterleri',
	others: 'Daha Fazla',

	// Error Messages
	itemsOverLimit: 'Belirtilen ad "%{itemName}" üst sınırı (20) aştı. Devam etmek için lütfen farklı bir ad belirleyin.',
	errorMessageLengthFolderName: 'Lütfen 255 karakteri geçmeyen bir klasör adı girin.',
	errorMessageLengthLinkName: 'Lütfen 255 karakteri aşmayan bir bağlantı adı girin.',
	toastLaunchPerspectiveError: '%{objectType} açılamıyor.',
	errorNoAccessTitle: 'Bu içeriğe erişiminiz yok gibi görünüyor',
	errorNoAccessBody: 'Sistem yöneticinizle iletişim kurun ya da şu bağlantıya bakın:',
	errorEnableExternalContent: 'Dış içerik etkinleştirme',

	//TableHeader
	lastAccessed: 'Son Erişildiği Tarih',
	location: 'Yer',
	tenant: 'Kiracı',

	// GetStartedTab
	getStartedLabel: 'IBM Cognos Analytics\'te çalışmaya devam edin',
	learningHowToLabel: 'Eğitim kaynakları',
	learningHowToDescription: 'Toplulukla bağlantı kurarak, belgeleri okuyarak ve videoları izleyerek daha çok bilgi sahibi olun ve yardım alın.',
	learningHowToActionLabel: 'Eğitim bölmesini başlat',
	howToVideosLabel: 'Nasıl yapılır videoları',
	howToVideosDescription: 'IBM Cognos Analytics\'in nasıl kullanılacağı hakkında bilgi edinin ve verilerinize ilişkin içgörüler edinmeye başlayın.',
	howToVideosActionLabel: 'Videoları izleyin',
	acceleratorCatalogLabel: 'Hızlandırıcılar Kataloğu',
	acceleratorCatalogDescription: 'Sektördeki kullanımların, en iyi uygulama kılavuzlarının, özel görselleştirmelerin de dahil olduğu büyüyen kataloğa göz atın.',
	acceleratorCatalogActionLabel: 'Kataloğa göz atın',
	sampleSectionTitle: 'Örnekler',
	sampleSectionDescription: 'Cognos Analytics\'in sunduğu tüm olanakları gösteren örneklerle siz de deneyin.',
	// Samples Section
	createDashboardSampleTitle: 'İlk gösterge panonuzu oluşturma',
	createDashboardSampleDescription: 'Cognos Dashboards ile analitik yolculuğunuza başlayın.',
	nlaSampleTitle: 'Örnek Rapor',
	nlaSampleDescription: 'Yıl sonu sadakat kartı üye etkinliğini analiz eden bu örnekle Cognos Analytics Raporlarıyla nelerin mümkün olduğunu keşfedin.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Sankey Chart gibi özel görselleştirmelerle görselleştirme kitaplığınızı genişletin.',
	viewAllSamplesActionLabel: 'Tüm örnekleri görüntüle',
	byFeatureTitle: 'Özelliğe göre',
	byFeatureDescription: 'Temel işlevsellik, özel denetimler, uzantılar, not defterleri ve göreli tarihler gibi özelliğe göre örneklere göz atın.',
	byIndustryTitle: 'Sektöre göre',
	byIndustryDescription: 'Otomotiv, bankacılık gibi sektöre göre örneklere göz atın.',
	// SamplesTab
	sampleTabTitle: 'Önceden oluşturulmuş örneklerimizden ilham alın',
	sampleTabLabel: 'IBM, iş ortakları ve müşterilerden daha fazla örnek görüntülemek için Hızlandırıcılar Kataloğu\'nu ziyaret edin',

	// quickLaunch
	quickLaunchLabel: 'Hızlı başlat',
	expand: 'Genişlet',
	collapse: 'Daralt',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Ne oluşturmak istediğinizi seçerek başlayın.',

	// contentPageView
	contentPageTitleLabel: 'İçerik',
	uploadFile: 'Verileri karşıya yükle',
	new: 'Yeni',
	create: 'Oluştur',
	more: 'Daha fazla',

	// open dialog
	selectDataSourcesToAdd: 'Eklenecek veri kaynağını/kaynaklarını seçin.',
	openDialogDefaultTitle: 'Aç',

	// save dialog
	save: 'Kaydet',
	saveAs: 'Farklı kaydet',
	saving: 'Kaydediliyor...',
	selectedDestination: 'Seçilen hedef: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' farklı bir tipte zaten var. Lütfen farklı bir ad seçin.',
	confirmOverwriteTitle: 'Var olan verilerin değiştirilmesini onayla',
	confirmOverwriteMsg: '\'%{nameOfFile}\' adlı dosya zaten var. Bu dosyanın verilerini, seçilen dosyada bulunan verilerle değiştirmek istiyor musunuz?',

	// copy move dialog
	copy: 'Kopyala',
	move: 'Taşı',
	copyOrMove: 'Kopyala veya taşı: ',
	copyOnly: 'Kopyala ',
	createShortcut: 'Kısayol oluştur',
	createShortcutDialogTitle: 'Kısayol oluştur: ',

	// External asset types
	wsProject: 'Watson Studio projesi',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Paket',
	dataModule: 'Veri modülü',
	exploration: 'Keşif',
	mode: 'Kip',
	live: 'Canlı',
	snapshot: 'Anlık Görüntü',
	noSnapshotsFound: 'Bir Anlık Görüntü bulunamadı',
	uploadedFile: 'Karşıya yüklenen dosya',
	fileUpload: 'Verileri karşıya yükle',
	dataSetEx: 'Veri kümesi',
	externalRepository: 'Dış havuz',
	queryMode: 'Sorgu kipi',
	queryModeCompatible: 'Uyumlu',
	queryModeDynamic: 'Dinamik',
	report: 'Rapor',
	activeReport: 'Etkin Rapor',
	query: 'Sorgu',
	analysis: 'Çözümleme',
	dashboard: 'Gösterge Panosu',
	dashboardTemplate: 'Gösterge panosu şablonu',
	jupyterNotebook: 'Not Defteri',
	wsNotebook: 'Watson Studio not defteri',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Hikaye',
	workspace: 'Çalışma Alanı',
	pagelet: 'Sayfa',
	content: 'İçerik',
	directory: 'Ad alanları',
	dataSet: 'Veri kümesi',
	powerPlayCube: 'PowerPlay Kübü',
	powerPlayReport: 'PowerPlay Raporu',
	powerPlay8Report: 'PowerPlay Raporu',
	setPowerPlay8ReportOptions: 'PowerPlay Rapor Seçeneklerini Ayarla',
	powerPlay8ReportView: 'PowerPlay Raporu Görünümü',
	reportTemplate: 'Rapor şablonu',
	packageConfigurations: 'Paket Yapılandırması',
	agent: 'Aracı',
	agentDefinition: 'Aracı Tanımı',
	agentDefinitionView: 'Aracı Görünümü',
	dataMovementTask: 'Veri Taşıma Görevi',
	dataMovementTaskAlias: 'Veri Taşıma Görevi Diğer Adı',
	document: 'Belge',
	DocumentRetention: 'Belge özellikleri',
	jobDefinition: 'İş Tanımlaması',
	job: 'İş',
	jobs: 'İşler',
	metricsDataSourceETLTask: 'Metrik Veri Kaynağı ETL Görevi',
	metricsExportTask: 'Metrik Dışa Aktarma Görevi',
	metricsFileImportTask: 'Metrik Dosya İçe Aktarma Görevi',
	metricsMaintenanceTask: 'Metrik Bakımı Görevi',
	planningTask: 'Planlama Görevi',
	shortcut: 'Kısayol',
	shortcuts: 'Kısayollar',
	URL: 'URL',
	launchable: 'Başlatılabilir',
	dataSetFolder: 'Veri Kümesi Klasörü',
	ViewAccessibleLabel: '%{label} görüntüle',
	overrideReportOptions: 'Varsayılan rapor seçeneklerini geçersiz kıl',
	formats: 'Biçimler',
	saveReport: 'Raporu kaydet',
	reportView: 'Rapor Görünümü',
	reportviews: 'Rapor Görünümleri',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel Verileri',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Rol',
	namespace: 'Ad alanı',
	namespaceFolder: 'Ad Alanı Klasörü',
	adminFolder: 'Yönetim Klasörü',
	//Details
	details: 'Ayrıntılar',
	open: 'Aç',
	created: 'Oluşturma',
	modified: 'Değiştirme',
	owner: 'Sahip',
	dataSource: 'Veri Kaynağı',
	share: 'Paylaş',
	addToFavorites: 'Sık kullanılanlara ekle',
	properties: 'Özellikler',
	detailsEmptyStateBody: 'Ayrıntılarını görüntülemek için bir öğe seçin',
	editNameAndDescription: 'Ad ve açıklamayı düzenle',
	none: 'Yok',
	setPdfOptions: 'PDF seçeneklerini ayarla',
	runOptions: 'Çalıştırma seçenekleri',

	//rename dialog
	nameInvalid: 'Ad geçersiz',
	namePlaceholder: 'Ad girin',
	description: 'Tanım',
	descriptionInvalid: 'Açıklama 350 karakteri aşamaz. ',
	descriptionPlaceholder: 'Bir Açıklama girin',
	errorMessageApostropheError: 'Lütfen hem \' hem de " karakteri içermeyen bir dosya adı girin',
	renameCollisionError: '%{name} zaten var. Farklı bir ad deneyin.',
	unknownRenameError: 'Öğe yeniden adlandırma başarısız oldu. Daha fazla yardım için yöneticinizle iletişim kurun.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Belirtilen klasör açılamıyor.',

	//Upload
	uploadToFolder: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction} konumuna yükle",
	uploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> konumuna yükle ve %{launchAction} başlat",
	quickUpload: "Hızlı karşıya yükleme",
	quickUploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> konumuna yüklemek için dosyaları sürükleyin ve bırakın ve aşağıdaki alanların birinde açın.",
	unsupportedFilesSingle: "%{files} Hızlı başlatma için geçersiz olduğundan karşıya yüklenemedi.",
	unsupportedFilesMultiple: "Hızlı başlatma seçeneğini kullanmak için seçtiğiniz tüm dosyaların geçerli olması gerektiğinden dosyalar karşıya yüklenmedi.",
	unsupportedFilesSingleInvalid: "%{files} geçersiz.",
	unsupportedFilesMultipleInvalid: "%{files} geçersiz.",
	supportedFileTypes: "Yalnızca aşağıdaki dosya tiplerine izin veriliyor: %{extensions}.",
	uploadDragAndDrop: "Sürükle ve Bırak",
	uploadDragAndDropMessage: "Dosyayı buraya sürükleyip bırakarak şu konuma karşıya yükleyin: <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Arama ölçütü \'%{searchTerm}\' kaydedildi.',
	searchWasntSaved: 'Arama ölçütü \'%{searchTerm}\' kaydedilmedi.',
	searchSuggestions: 'Öneriler',
	savedSearch: 'Kayıtlı aramalar',
	searchWasDeleted: 'Arama ölçütü \'%{searchTerm}\' silindi.',
	searchWasntDeleted: 'Arama ölçütü \'%{searchTerm}\' silinmedi.',
	savedBarTitle: 'Cognos Analytics\'te Ara',
	searchContentPageTitle: 'Ara',
	searchContentPageTitleLabel: '\'%{searchTerm}\' için sonuçlar gösteriliyor',
	showingSearchRsult: '%{resultCount} öğe gösteriliyor',
	saveSearch: 'Aramayı kaydet',
	saveTenSearches: '10 arama kaydedebilirsiniz.',
	deleteASearch: 'Birini kaydetmek için diğerini silin.',
	close: 'Kapat',
	allContent: 'Tüm İçerik',
	searchResultIn: 'Sonuçlarda ara: ',
	//recent view
	recents: 'En Son',
	noAccessRecent: 'Erişim yok',
	noAccessRecentMsg: 'Bu varlığa erişiminiz yok. Devre dışı bırakılmış ya da silinmiş olabilir veya izinleriniz azaltılmış olabilir. Varlığın beklenen kaynak konumundaki durumunu doğrulayın. Tamam düğmesini tıklatarak, varlığı en son öğelerinizden kaldırabilirsiniz.',
	noAccessMsg: 'Bu varlığa erişiminiz yok. Devre dışı bırakılmış ya da silinmiş olabilir veya izinleriniz azaltılmış olabilir.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} öğe seçildi',
	itemSelected: '%{nameOfSelection} öğesi seçildi',

	//properties
	general: 'Genel',
	schedule: 'Program',
	permission: 'İzinler',
	capabilities: 'Yetenekler',
	propertiesTabsLabel: 'Özellikler içeriği',
	searchPath: 'Arama yolu',
	id: 'Tanıtıcı',
	language: 'Dil',
	setLanguage: 'Dili ayarla',
	entryOptions: 'Giriş seçenekleri',
	setPackage: 'Paketi ya da modülü ayarla',
	sourcePackage: 'Kaynak paketi ya da veri modülü',
	associatedSourceAgent: 'Kaynak paketi',
	setAssociatedSourceAgent: 'Paketi ayarla',
	sourceAgent: 'Kaynak aracısı',
	setSourceAgent: 'Kaynak aracısını ayarla',
	setCapabilities: 'Yetenekleri ayarla',
	disableEntry: 'Bu girdiyi devre dışı bırak',
	hideEntry: 'Bu girdiyi gizle',
	permissions: 'İzinler',
	promptForValues: 'Değerler için bilgi isteminde bulun',
	yes: 'Evet',
	no: 'Hayır',
	setValues: 'Yeni değerler',
	moreOptions: 'Diğer seçenekler',
	reportFormat: 'Rapor Biçimi',
	enableAccessibilitySupport: 'Erişilebilirlik desteğini etkinleştir',
	displayOfRunHistory: 'Çalıştırma geçmişinin görüntülenmesi',
	occurrences: 'Gerçekleşen Olaylar',
	days: 'Gün',
	months: 'Ay',
	displayOfReportOutputVersions: 'Rapor çıktısı sürümünün görüntülenmesi',
	defaultDisplayOfPortalAction: 'Varsayılan portal eylemi',
	viewMostRecentReport: 'En son raporu görüntüle',
	runTheReport: 'Raporu çalıştır',
	openWithReportStudio: 'Report Studio ile aç',
	rowsPerPageInHtmlReports: 'HTML raporlarındaki sayfa başına satır sayısı',
	enableSelectionBasedInteractivity: 'Seçim tabanlı etkileşimi etkinleştir',
	enableAlertsAboutNewVersions: 'Yeni sürümlere ilişkin uyarıları etkinleştir',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Kaydedilmiş çıktı sürümlerinde gelişmiş kullanıcı özelliklerini etkinleştir',
	enableCommentsInSavedOutputVersions: 'Kaydedilmiş çıktı sürümlerinde açıklamaları etkinleştir',
	run: 'Çalıştır',
	runWithUsersCredentials: 'Kullanıcı kimlik bilgileri ile',
	runWithOwnerCapabilities: 'Sahip yeteneği ile',
	runAsOwner: '%{ownerName} olarak',
	actionLabelOn: 'Açık',
	actionLabelOff: 'Kapalı',
	openReport: 'Düzenle',
	openAnalysis: 'Analysis Studio ile aç',
	openQuery: 'Query Studio ile aç',
	openPowerPlay8Report: 'PowerPlay Studio ile aç',
	openInteractiveReport: 'Düzenle',
	read: 'Oku',
	write: 'Yaz',
	execute: 'Yürüt',
	setPolicy: 'İlke Ayarla',
	full: 'Tam',
	traverse: 'Geçiş yap',
	grant: 'İzin Ver',
	deny: 'Reddet',
	permissionCustom: 'Özel',
	permissionDetailsColumnAccess: 'Erişim',
	permissionDetailsColumnPermission: 'İzin',
	permissionDetailsColumnAction: 'İşlem',
	permissionSetAccess: 'Erişim belirle',
	permissionRead: 'Oku',
	permissionRun: 'Çalıştır',
	permissionWrite: 'Yaz',
	permissionFull: 'Tam',
	unavailable: 'Yok',
	unkownSource: 'Bilinmiyor, ayrıntılar için raporu açın',
	tenantSettings: 'Kiracı ayarları',
	tenantSet: 'Kiracı güncellendi',
	tenantSetError: 'Kiracı ayarlanırken hata oluştu',
	tenantClear: 'Kiracı temizlendi',
	tenantClearError: 'Kiracı temizlenirken hata oluştu',
	shortcutTo: 'Kısayol hedefi',
	sourceReport: 'Kaynak rapor',
	setSourceReport: 'Kaynak raporunu ayarla',
	setSourceLocation: 'Kaynak %{itemName} Konumunu ayarla',
	linkPackageOrModule: '%{itemName} öğesini bir paket veya veri modülüne bağla',
	linkPackage: '%{itemName} öğesini bir pakete bağla',
	externalRepositories: 'Dış havuzlar',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Yenilenme zamanı',
	size: 'Büyüklük',
	tenantsWarningMessage: 'Bir girişin kiracısı değiştirildiğinde, alt girişlerin kiracısı da değiştirilir.',
	confirmClearTenantText: 'Değerin \'Yok\' olarak temizlenmesi, diğer kiracıların içeriğe erişmelerine izin verebilir. Girişi genel kullanıma sunmak için Tamam\'ı veya geçerli kiracıyı tutmak için İptal\'i tıklatın.',
	confirmClearTenant: 'Kiracıyı temizlemeyi onayla',
	currentValues: 'Geçerli değerler',
	emptyPromptValues: 'Şu anda herhangi bir değer yok',
	editValues: 'Değerleri düzenle',
	clear: 'Temizle',
	source: 'Kaynak',
	dataRefreshed: 'Veriler yenilendi',
	//PDF options
	pdfOptions: 'PDF seçenekleri',
	set: 'Ayarla',
	portrait: 'Dikey',
	landscape: 'Yatay',
	letter: 'Harf',
	legal: 'Yasal',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Yön',
	pageDefination: 'Kağıt boyutu',
	openPasswordRequired: 'Raporu açmak için parola iste',
	accessPasswordRequired: 'Rapora erişmek için parola iste',
	emptyPassword: 'Parola boş olamaz',
	password: 'Parola',
	enterPassword: 'Parola gir',
	confirmPassword: 'Parolayı doğrula',
	passwordMatchError: 'Parolalar uyuşmuyor',
	gateway: 'Ağ geçidi',
	pageLayout: 'Sayfa Düzeni',
	pageStyle: 'Stil',
	setUrl: 'URL ayarla',
	numberRows: 'Satır sayısı',
	numberColumns: 'Sütun sayısı',
	timeToRefresh: 'Yenileme süresi',
	lastRefreshedBy: 'Yenileyen',
	unknown: 'Bilinmiyor',
	unknownUpdateError: 'Öğe güncellenemedi. Daha fazla yardım için yöneticinizle iletişim kurun.',
	editQuery: 'Sorguyu Düzenle',
	greaterOrEqual: '%{upperboundValue} değerinden büyük veya buna eşit',
	lessOrEqual: '%{lowerboundValue} değerinden küçük veya buna eşit'
});
